export default function(colorString, alpha) {
  return colorString && colorString.replace(/1\)$/, `${alpha})`);
}
